(() => {
  if (window.vedbutikkQuickAddInitialized) {
    return;
  }

  window.vedbutikkQuickAddInitialized = true;

  const getQuantity = (quickAdd) => {
    const preset = quickAdd.querySelector(
      '[data-quantity-preset]'
    );

    const customInput = quickAdd.querySelector(
      '[data-custom-quantity]'
    );

    if (!preset) {
      return 1;
    }

    if (preset.value === 'custom') {
      const customValue = parseInt(
        customInput?.value || '1',
        10
      );

      return Math.max(1, customValue || 1);
    }

    return Math.max(
      1,
      parseInt(preset.value || '1', 10)
    );
  };

  const syncQuantity = (quickAdd) => {
    const quantityField = quickAdd.querySelector(
      '[data-quantity-field]'
    );

    const submitButton = quickAdd.querySelector(
      '[data-quick-add-submit]'
    );

    const quantity = getQuantity(quickAdd);

    if (quantityField) {
      quantityField.value = quantity;
    }

    if (submitButton && !submitButton.disabled) {
      submitButton.textContent =
        `Legg til ${quantity} i handlekurven`;
    }

    return quantity;
  };

  const updateCustomVisibility = (quickAdd) => {
    const preset = quickAdd.querySelector(
      '[data-quantity-preset]'
    );

    const customWrapper = quickAdd.querySelector(
      '[data-custom-quantity-wrapper]'
    );

    const customInput = quickAdd.querySelector(
      '[data-custom-quantity]'
    );

    if (!preset || !customWrapper) {
      return;
    }

    const isCustom = preset.value === 'custom';

    customWrapper.hidden = !isCustom;

    if (isCustom && customInput) {
      window.setTimeout(() => {
        customInput.focus();
        customInput.select();
      }, 0);
    }

    syncQuantity(quickAdd);
  };

  document.addEventListener('click', (event) => {
    const revealButton = event.target.closest(
      '[data-quick-add-reveal]'
    );

    if (!revealButton) {
      return;
    }

    const quickAdd = revealButton.closest(
      '[data-quick-add]'
    );

    if (!quickAdd) {
      return;
    }

    const panel = quickAdd.querySelector(
      '[data-quick-add-panel]'
    );

    if (!panel) {
      return;
    }

    revealButton.hidden = true;
    revealButton.setAttribute(
      'aria-expanded',
      'true'
    );

    panel.hidden = false;

    updateCustomVisibility(quickAdd);
    syncQuantity(quickAdd);
  });

  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-quantity-preset]')) {
      const quickAdd = event.target.closest(
        '[data-quick-add]'
      );

      if (quickAdd) {
        updateCustomVisibility(quickAdd);
      }
    }
  });

  document.addEventListener('input', (event) => {
    if (!event.target.matches('[data-custom-quantity]')) {
      return;
    }

    const quickAdd = event.target.closest(
      '[data-quick-add]'
    );

    if (quickAdd) {
      syncQuantity(quickAdd);
    }
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest(
      '.quick-add__form'
    );

    if (!form) {
      return;
    }

    event.preventDefault();

    const quickAdd = form.closest(
      '[data-quick-add]'
    );

    if (!quickAdd) {
      return;
    }

    const submitButton = form.querySelector(
      '[data-quick-add-submit]'
    );

    const message = form.querySelector(
      '[data-quick-add-message]'
    );

    const selectedQuantity =
      syncQuantity(quickAdd);

    submitButton.disabled = true;
    submitButton.textContent = 'Legger til …';

    if (message) {
      message.textContent = '';
      message.classList.remove(
        'quick-add__message--error'
      );
    }

    try {
      const addUrl = form.action.endsWith('.js')
        ? form.action
        : `${form.action}.js`;

      const response = await fetch(addUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/json'
        },
        body: new FormData(form)
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(
          result.description ||
          result.message ||
          'Varen kunne ikke legges i handlekurven.'
        );
      }

      const cartResponse = await fetch(
        quickAdd.dataset.cartUrl,
        {
          headers: {
            Accept: 'application/json'
          }
        }
      );

      if (!cartResponse.ok) {
        throw new Error(
          'Handlekurven kunne ikke oppdateres.'
        );
      }

      const cart = await cartResponse.json();

      document
        .querySelectorAll('[data-cart-count]')
        .forEach((counter) => {
          counter.textContent = cart.item_count;
        });

      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          detail: {
            cart,
            addedItem: result
          }
        })
      );

      submitButton.textContent = 'Lagt til ✓';

      if (message) {
        message.textContent =
          `${selectedQuantity} stk. er lagt i handlekurven.`;
      }

      window.setTimeout(() => {
        submitButton.disabled = false;
        syncQuantity(quickAdd);
      }, 1600);
    } catch (error) {
      submitButton.disabled = false;

      if (message) {
        message.textContent =
          error.message ||
          'Noe gikk galt. Prøv på nytt.';

        message.classList.add(
          'quick-add__message--error'
        );
      }

      syncQuantity(quickAdd);
    }
  });
})();